<div
  [class.disabled]="disabled && !isSelected"
  *ngIf="text"
  class="cet-pill"
  [class.selected]="isSelected || Close"
  (click)="isSelected = !Close && !isSelected"
  (click)="select()"
>
  <div class="pill-content">
    <span>{{ text }}</span>
    <input
      type="checkbox"
      class="form-check-input"
      [(ngModel)]="isSelected"
      *ngIf="Select"
      style="cursor: pointer; pointer-events: none"
    />
    <span *ngIf="Close" (click)="close()">
      <svg width="16px" height="16px" class="closeIcon">
        <use xlink:href="assets/images/icons.svg#x-thick"></use>
      </svg>
    </span>
  </div>
</div>
